module.exports = __webpack_public_path__ + "img/penguin-bubble.42946866.svg";